/**
 * Math Utility Functions for Horseshoe Tunnel
 * Angle conversion and mathematical helpers
 */

/**
 * Convert degrees to radians
 * @param {number} angle - Angle in degrees
 * @returns {number} Angle in radians
 */
export const toRadians = (angle) => angle * (Math.PI / 180);

/**
 * Convert radians to degrees
 * @param {number} radian - Angle in radians
 * @returns {number} Angle in degrees
 */
export const toDegree = (radian) => radian * (180 / Math.PI);
